import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { ShowDisclosuresData } from "../../../../models/show-disclosures-data.model";
import { OfferActionsInternalService } from "../../../../services/actions/offer-actions.internal.service";
import { OfferLocCalculator } from "../../../../services/offer-loc-calculator";
import { OfferBundleStatus } from "../../../../models/offer.model";
import {
  isLargeLoanProgramOffer,
  LargeLoanProgramBankIntegrationNotice,
} from "../../../../models/large-loan-program.model";

@Component({
    selector: "ifc-offer-loc-details-content",
    templateUrl: "./offer-loc-details-content.component.html",
    styleUrls: ["./offer-loc-details-content.component.scss"],
    standalone: false
})
export class OfferLocDetailsContentComponent implements OnInit, OnChanges {
  @Input()
  calculator: OfferLocCalculator;

  @Input()
  largeLoanProgramOffered: boolean;

  isRenewal: boolean;
  isLargeLoanProgram: boolean;
  offerBundleStatusEnum = OfferBundleStatus;
  readonly bankIntegrationNotice = LargeLoanProgramBankIntegrationNotice;

  constructor(private actionsService: OfferActionsInternalService) {}

  ngOnInit(): void {
    this.isRenewal = this.calculator.application.renewalForLoanUniqueId
      ? true
      : false;
  }

  // The parent swaps the calculator when the applicant switches between LOC offers.
  ngOnChanges(): void {
    this.isLargeLoanProgram = isLargeLoanProgramOffer(
      this.calculator?.applicationOfferBundle
    );
  }

  onLinkBank(entityId: number): void {
    this.actionsService.linkBank(entityId);
  }

  onDocumentsClick(applicationId: number, offerBundleId: number): void {
    this.actionsService.openDocumentsDetails(applicationId, offerBundleId);
  }

  onShowDisclosures(data: ShowDisclosuresData) {
    this.actionsService.showDisclosures(data);
  }
}
